import { useRouter } from "next/router";
import { FC, useEffect, useState } from "react";
import Button from "~/components/Button";
import Icon from "~/components/Icon";
import ModalContainer from "~/components/Modals/ModalContainer";
import StepReview from "./step-review";
import classNames from "classnames";

interface FormValues {
  email_address: string;
  name: string;
  content?: string;
  files?: IFile[];
  star?: number;
  summary?: string;
}

type ModalWriteReviewProps = {
  sku?: string;
  className?: string;
  btnClassName?: string;
};

const ModalWriteReview: FC<ModalWriteReviewProps> = ({
  sku,
  className = "",
  btnClassName = "",
}) => {
  const router = useRouter();
  const query = router.query;
  const isDefaultOpen = query.review === "open";
  const [open, setOpen] = useState(isDefaultOpen);

  const onCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (query.review === "open") {
      const reviewTabsElement = document.getElementById("review-tabs");
      reviewTabsElement?.scrollIntoView({ behavior: "smooth" });
      setOpen(true);
      const newQuery = { ...query };
      delete newQuery.review;
      router.replace({ query: { ...newQuery } }, undefined, { shallow: true });
    }
  }, [query]);

  return (
    <div className={`${className}`}>
      <span onClick={() => setOpen(true)} className="">
        <Button
          className={classNames("", btnClassName)}
          type="outline"
          variant="secondary"
        >
          Write a review
        </Button>
      </span>
      <ModalContainer
        open={open}
        onClose={onCancel}
        type="bottom-sheet"
        className="!max-w-[720px]"
        wrapperClassName="px-4 flex flex-col gap-1"
      >
        <div className="flex justify-end items-center py-1">
          <div className="cursor-pointer">
            {/* <div className="hidden">
              <Popover
                content={
                  <div className="">
                    <div className="">How Customer Review work?</div>
                    <div className="text-wrap">
                      Customers ask questions, sellers and community members
                      provide answers, users vote on helpful responses,
                      fostering trust and facilitating informed purchasing
                      decisions.
                    </div>
                  </div>
                }
              >
                <Icon name="info-circle" />
              </Popover>
            </div> */}
          </div>
          <span className="cursor-pointer">
            <Icon name="close" onClick={onCancel} size={32} />
          </span>
        </div>
        <StepReview sku={sku} onCancel={onCancel} />
      </ModalContainer>
    </div>
  );
};

export default ModalWriteReview;
